import RadioComponent from '../../../Input/Radio.component';
import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';

interface CandidateDuplicateListProps {
  id: number;
  fullName: string;
  selectedCandidate: number;
  setSelectedCandidate: (id: number) => void;
  email?: string;
  phone?: string;
}

const StyledCandidateDuplicateTextEllipsis = css`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 250px;
`;

const StyledCandidateDuplicateListWrapper = styled.div`
  margin-top: 8px;
`;

const StyledCandidateDuplicateListText = styled.div`
  ${StyledCandidateDuplicateTextEllipsis}
`;

const StyledCandidateDuplicateListFullName = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;

  ${StyledCandidateDuplicateTextEllipsis}
`;

const notaAssign = {
  email: 'Не задана',
  phone: 'Не задан',
};

const CandidateDuplicateList: FC<CandidateDuplicateListProps> = ({
  id,
  fullName,
  phone,
  email,
  selectedCandidate,
  setSelectedCandidate,
}) => {
  const { t } = useTranslation();

  return (
    <StyledCandidateDuplicateListWrapper>
      <RadioComponent
        selected={id === selectedCandidate}
        description={
          <div>
            <StyledCandidateDuplicateListFullName>
              {fullName}
            </StyledCandidateDuplicateListFullName>
            <StyledCandidateDuplicateListText>
              {`${t('Email')}: ${email || notaAssign.email}`}
            </StyledCandidateDuplicateListText>
            <StyledCandidateDuplicateListText>
              {`${t('Phone')}: ${phone || notaAssign.phone}`}
            </StyledCandidateDuplicateListText>
          </div>
        }
        handleChange={() => setSelectedCandidate(id)}
      />
    </StyledCandidateDuplicateListWrapper>
  );
};

export default CandidateDuplicateList;
